import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import { availableLanguages } from 'app/config'

const state = {
  currentPlatform: 'desktop',
  currentLanguage: 'pt-BR',
  currentTemplate: 'desktop-pt-BR',
  checkoutName: null,
  checkoutDescription: null,
  editMode: false,
  insertMode: false,
  builderLoading: {
    show: false,
    message: null
  },
  currentComponent: null,
  currentComponentName: null,
  targetComponent: null,
  componentSource: null,
  checkout: false,
  imageList: {},
  currentImages: [],
  activeRow: null,
  activeColumn: null,
  templates: {},
  lastInsertComponent: {
    components: {},
    position: {
      template: null,
      row: null,
      col: null
    }
  },
  checkoutStatus: '',
  checkoutStatusAccept: true,
  lastUpdatedPlatform: null,
  checkoutHistory: null,
  currentEditForm: null,
  templateHasUnsavedChanges: false,
  unsavedWarning: {
    show: false,
    logout: false
  },
  orderBumpData: {},
  rowEditMode: false,
  justPublishedCheckout: {},
  layoutIsCopied: false,
  previewWasOpen: false,
  productPlansEarlyRenewal: [],
  earlyRenewalData: {},
  currentProductEarlyRenewal: null,
  productsWithEnrichedData: {},
  skipRouteInit: false,
  previewInProgress: false
}

const checkoutPlatforms = ['desktop', 'mobile']

checkoutPlatforms.forEach(platform => {
  availableLanguages?.forEach(language => {
    state.templates[platform + '-' + language] = {
      rows: []
    }
  })
})

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
